import { useCallback } from 'react';

/** Scrolls to the top of the page; jumps instead when the visitor prefers reduced motion. */
export function useScrollToTop(): () => void {
  return useCallback(() => {
    const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    window.scrollTo({ top: 0, behavior: reduce ? 'auto' : 'smooth' });
  }, []);
}
